export const BTN_TYPE = {
	outline: "outline",
	solid: "solid",
	link: "link",
};

export const BADGE_TYPE = {
	chip: "chip",
	solid: "solid",
};

export const MESSAGE_ERROR_SERVER = {
	DATA_VALIDATION_ERROR: "DATA_VALIDATION_ERROR",
	FORMAT_FILE_ERROR: "FORMAT_FILE_ERROR",
	SAVE_ERROR: "SAVE_ERROR",
	SAVE_DATA_ERROR: "SAVE_DATA_ERROR",
	REMOVE_DATA_ERROR: "REMOVE_DATA_ERROR",
	EXCEPTION_ERROR: "EXCEPTION_ERROR",
	PROCESS_DATABASE_ERROR: "PROCESS_DATABASE_ERROR",
}